export const scrollToEvent = (offset, callback) => {
  const fixedOffset = offset.toFixed();
  const onScroll = function () {
    if (window.scrollY.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll);
      callback();
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: 'smooth',
  });
};

// export const validation = (el, operation) => {

//     if (operation === 'add') {
//       el.closest('fieldset').classList.add('has-error');
//       el.closest('fieldset').setAttribute(
//         'data-error',
//         'To pole jest obowiązkowe, aby wziąć udział w konkursie',
//       );
//     } else if (operation === 'remove') {
//       el.closest('fieldset').classList.remove('has-error');
//       el.closest('fieldset').setAttribute('data-error', '');
//     }
//   };

export const validation = (el, operation) => {
  const fieldset = el.closest('fieldset');
  
  const isUploadField = el.getAttribute('type') === 'file';

  if (operation === 'add') {
    if (!isUploadField) {
      fieldset.classList.add('has-error');
      fieldset.setAttribute(
        'data-error',
        'To pole jest obowiązkowe, aby wziąć udział w konkursie',
      );
    }
  } else if (operation === 'remove') {
    fieldset.classList.remove('has-error');
    fieldset.setAttribute('data-error', '');
  }
};

export const validateField = (el, char) => {
  const isValid = el.value.trim().length > char;

  if (!isValid) {
    validation(el, 'add');
  } else {
    validation(el, 'remove');
  }
  return isValid;
};

export const validateCheckbox = (el) => {
  if (!el.checked) {
    validation(el, 'add');
  } else {
    validation(el, 'remove');
  }
  return el.checked;
};

export const checkEmail = (emailAddress) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z\-0-9]{2,}))$/;
  return re.test(String(emailAddress).toLowerCase());
};

export const validateEmail = (el) => {
  const isValid = checkEmail(el.value);

  if (!isValid) {
    validation(el, 'add');
  } else {
    validation(el, 'remove');
  }
  return isValid;
};

export const declination = (num, elem, word) => {
  if (num === 1) {
    elem.setAttribute('data-text', `${word}a`);
  } else if ([2, 3, 4, 22, 23, 24, 32, 33, 34, 42, 43, 44, 52, 53, 54].indexOf(num) > -1) {
    elem.setAttribute('data-text', `${word}y`);
  } else {
    elem.setAttribute('data-text', word);
  }
};

const spinnerHtml = `<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
   <circle class="path" fill="none" stroke-width="3" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
</svg>`;

export const createSpinner = (formEl, opacity) => {
  formEl.querySelectorAll('input, textarea, button').forEach((input) => {
    input.setAttribute('disabled', '');
  });
  if (opacity) {
    formEl.classList.add('form-opacity');
  }
  const spinnerWrapper = document.createElement('div');
  spinnerWrapper.classList.add('spinner-wrapper');
  spinnerWrapper.innerHTML = spinnerHtml;
  formEl.append(spinnerWrapper);
};

export const getIndex = (item) => {
  const nodes = Array.prototype.slice.call(item.parentElement.children);
  return nodes.indexOf(item);
};

export const checkItemsCountForGridType = (selector) => {
  if (document.querySelector(`${selector} .wrapper`)) {
    const itemsCount = document.querySelector(`${selector} .wrapper`).children.length;
    if (!(itemsCount % 3 === 0)) {
      document.querySelector(`${selector} .wrapper`).classList.add('grid--2');
    }
  }
};
